import BulkUploadSelect from './BulkUploadSelect.component';

export default BulkUploadSelect;